<template>
  <div v-show="isShow">
    <div class="mask-layer"></div>
    <div class="loading-center">
      <div class="loading">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
      <div class="loading-message" v-text="showText">加载中...</div>
    </div>
  </div>
</template>
<style lang="less">
/*遮罩层*/
.mask-layer {
  position: fixed;
  width: 100%;
  top: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0);
  z-index: 998;
}
.loading-center {
  position: fixed;
  width: 2.5rem;
  left: 50%;
  top: 40%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.6);
  border-radius: 0.1rem;
  padding: 0.3rem 0;
  text-align: center;
  font-size: 16px;
  margin-left: -1.25rem;
  z-index: 1010;
}
@media screen and (max-width: 321px) {
  .loading-center {
    font-size: 16px;
  }
}
@media screen and (min-width: 321px) and (max-width: 400px) {
  .loading-center {
    font-size: 17px;
  }
}
@media screen and (min-width: 400px) {
  .loading-center {
    font-size: 19px;
  }
}
.loading-message {
  color: #fff;
  padding-top: 0.16rem;
}
.loading,
.loading > div {
  position: relative;
  box-sizing: border-box;
}

.loading {
  display: block;
  font-size: 0;
  color: rgba(255, 255, 255, 0.9);
}

.loading.la-dark {
  color: #333;
}

.loading > div {
  display: inline-block;
  float: none;
  background-color: currentColor;
  border: 0 solid currentColor;
}

.loading {
  width: 32px;
  height: 32px;
}

.loading > div {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 8px;
  height: 8px;
  margin-top: -4px;
  margin-left: -4px;
  border-radius: 100%;
  animation: ball-spin-clockwise 1s infinite ease-in-out;
}

.loading > div:nth-child(1) {
  top: 5%;
  left: 50%;
  animation-delay: -0.875s;
}

.loading > div:nth-child(2) {
  top: 18.1801948466%;
  left: 81.8198051534%;
  animation-delay: -0.75s;
}

.loading > div:nth-child(3) {
  top: 50%;
  left: 95%;
  animation-delay: -0.625s;
}

.loading > div:nth-child(4) {
  top: 81.8198051534%;
  left: 81.8198051534%;
  animation-delay: -0.5s;
}

.loading > div:nth-child(5) {
  top: 94.9999999966%;
  left: 50.0000000005%;
  animation-delay: -0.375s;
}

.loading > div:nth-child(6) {
  top: 81.8198046966%;
  left: 18.1801949248%;
  animation-delay: -0.25s;
}

.loading > div:nth-child(7) {
  top: 49.9999750815%;
  left: 5.0000051215%;
  animation-delay: -0.125s;
}

.loading > div:nth-child(8) {
  top: 18.179464974%;
  left: 18.1803700518%;
  animation-delay: 0s;
}

.loading.la-sm {
  width: 16px;
  height: 16px;
}

.loading.la-sm > div {
  width: 4px;
  height: 4px;
  margin-top: -2px;
  margin-left: -2px;
}

.loading.la-2x {
  width: 64px;
  height: 64px;
}

.loading.la-2x > div {
  width: 16px;
  height: 16px;
  margin-top: -8px;
  margin-left: -8px;
}

.loading.la-3x {
  width: 96px;
  height: 96px;
}

.loading.la-3x > div {
  width: 24px;
  height: 24px;
  margin-top: -12px;
  margin-left: -12px;
}

@keyframes ball-spin-clockwise {
  0%,
  100% {
    opacity: 1;
    transform: scale(1);
  }

  20% {
    opacity: 1;
  }

  80% {
    opacity: 0;
    transform: scale(0);
  }
}
.spinner-cc {
  position: relative;
  display: inline-block;
  vertical-align: middle;
  width: 0.6rem;
  height: 0.6rem;
}
.spinner-cc div {
  background-color: white;
  position: absolute;
  width: 8%;
  height: 25%;
  top: 60%;
  left: 50%;
  margin-left: -4.15%;
  opacity: 0;
  border-bottom-left-radius: 0.7rem 1.2rem;
  border-bottom-right-radius: 0.7rem 1.2rem;
  -webkit-transform-origin: center -80%;
  -ms-transform-origin: center -80%;
  transform-origin: center -80%;
  -webkit-animation: fade 1s linear infinite;
}
.spinner-cc div.bar1 {
  -webkit-transform: rotate(0deg);
  -webkit-animation-delay: 0s;
}
.spinner-cc div.bar2 {
  -webkit-transform: rotate(30deg);
  -webkit-animation-delay: -0.9167s;
}
.spinner-cc div.bar3 {
  -webkit-transform: rotate(60deg);
  -webkit-animation-delay: -0.833s;
}
.spinner-cc div.bar4 {
  -webkit-transform: rotate(90deg);
  -webkit-animation-delay: -0.75s;
}
.spinner-cc div.bar5 {
  -webkit-transform: rotate(120deg);
  -webkit-animation-delay: -0.667s;
}
.spinner-cc div.bar6 {
  -webkit-transform: rotate(150deg);
  -webkit-animation-delay: -0.5833s;
}
.spinner-cc div.bar7 {
  -webkit-transform: rotate(180deg);
  -webkit-animation-delay: -0.5s;
}
.spinner-cc div.bar8 {
  -webkit-transform: rotate(210deg);
  -webkit-animation-delay: -0.41667s;
}
.spinner-cc div.bar9 {
  -webkit-transform: rotate(240deg);
  -webkit-animation-delay: -0.333s;
}
.spinner-cc div.bar10 {
  -webkit-transform: rotate(270deg);
  -webkit-animation-delay: -0.25s;
}
.spinner-cc div.bar11 {
  -webkit-transform: rotate(300deg);
  -webkit-animation-delay: -0.1667s;
}
.spinner-cc div.bar12 {
  -webkit-transform: rotate(330deg);
  -webkit-animation-delay: -0.0833s;
}
@-webkit-keyframes fade {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
</style>
<script>
export default {
  data() {
    return {
      isShow: false,
      showText: "加载中...",
    };
  },
  computed: {},
  methods: {
    /**
     * 显示动画loading
     */
    show(text) {
      this.isShow = true;
      this.showText = text;
    },
    /**
     * 隐藏动画loading
     */
    hide() {
      this.isShow = false;
    },
  },
};
</script>
